import React from 'react';

import {MdTextField} from 'core/components/fields/fields';
import Form, {FIELDDEFDISPLAYTYPE} from 'core/form/form';
import {createForm} from 'core/form/createForm';
import {FormProps, lovValue} from 'core/form/formUtils';
import StyledSelect from 'core/components/fields/styledSelect';
import NumberField from 'core/components/fields/numberField';
import {BlockComp} from 'core/components/blockComp/blockComp';
import {Validate} from 'core/form/validate';
import {HasLength, IsNumber, Min, NumberFormat} from 'core/form/rules';
import {optionsSearch} from "core/common/service/commonDataService";
import {action, observable} from "mobx";
import {observer} from "mobx-react";
import {ADDRESSPLACETYPE, PARTYROLE} from "party/partyDomain";
import StyledDatePicker from "core/components/fields/styledDatePicker";
import {Shipment, SHIPMENTSTATUS_COLORS, ShipmentVisit} from "shipment/shipmentDomain";
import {grey400} from "material-ui/styles/colors";
import RadioButtonField from "core/components/fields/radioButtonField";
import {LovItem} from "core/metamodel/mdEntity";
import securityService from "core/security/securityService";
import shipmentService from "shipment/shipmentService";
import {ShipmentVisitClosedContent} from "shipment/component/shipmentVisitDriverForm";
import mdEntityService from "core/metamodel/mdEntityService";
import {loc} from "core/common/config/locales";
import productService from "product/productService";
import {Vehicle} from "product/productDomain";
import {ShipmentRequestedTime} from "shipment/component/shipmentRequestedTime";


@createForm({
  formName: 'ShipmentOutgoingForm',
  fields: [{
    name: 'shipmentDate',
    validators: ['IsRequired']
  }, {
    name: 'shipmentStatus',
    validators: ['IsRequired'],
    displayType: FIELDDEFDISPLAYTYPE.radioButton
  }, {
    name: 'comment',
    displayType: FIELDDEFDISPLAYTYPE.textArea
  }, {
    name: 'shippedTo',
    validators: ['IsRequired']
  }, {
    name: 'shippedToAddress',
    validators: ['IsRequired']
  }, {
    name: 'shippedToPlaceDesc'
  }, {
    name: 'registrationNumber'
  }, {
    name: 'shippedFromPlace'
  }, {
    name: 'plannedPaletteCount',
    validators: ['IsNumber']
  }, {
    name: 'loadedPaletteCount',
    validators: ['IsNumber']
  }, {
    name: 'notLoadedPaletteCount',
    validators: ['IsNumber'],
  }, {
    name: 'loadingNumber'
  }, {
    name: 'loadingTruckCount',
    validators: ['IsNumber']
  }, {
    name: 'unloadingTruckCount',
    validators: ['IsNumber']
  }, {
    name: 'shipmentVisit'
  }, {
    name: 'transportationType',
    displayType: FIELDDEFDISPLAYTYPE.radioButton
  }, {
    name: 'maxWaitingTime'
  }, {
    name: 'disponentParty'
  }, {
    name: 'hauler'
  }, {
    name: 'pickingList'
  }, {
    name: 'vehicle'
  }, {
    name: 'visitOrder',
    validators: ['IsNumber', 'IsRequired']
  }]
}, () => <noscript/>)
@observer
export default class ShipmentOutgoingForm extends React.Component<FormProps<Shipment, Shipment>> {

  @observable shipmentVisit: ShipmentVisit;

  componentDidMount() {
    let {dataObject, form} = this.props;
    let partyId = lovValue(dataObject.shippedTo);

    console.debug("componentDidMount = populateDropdowns, partyId ", partyId);
    return this.populateDropdowns(partyId, dataObject, form);
  }

  componentDidUpdate(prevProps: FormProps<Shipment, Shipment>) {
    let {dataObject, form} = this.props;

    if (prevProps.dataObject.shipmentId !== dataObject.shipmentId) { // kvuli copy nebo horizontalnimu posunu
      let partyId = lovValue(dataObject.shippedTo);
      console.debug("componentDidUpdate - populateDropdowns, partyId ", partyId);
      return this.populateDropdowns(partyId, dataObject, form);
    }
  }

  private populateDropdowns(partyId, dataObject: Shipment, form: Form<Shipment>) {
    return (Promise.all([((partyId != null) ? optionsSearch('Address', {partyId}) : Promise.resolve({options: []})),
      optionsSearch('AddressPlace', {
        partyId: securityService.currentTenant.party.value,
        placeType: ADDRESSPLACETYPE.EXPEDITION
      }),
      (dataObject.shipmentVisit) ? shipmentService.readShipmentVisit(lovValue(dataObject.shipmentVisit)) : Promise.resolve(null)]))
      .then(action("onShippedToChange-cb1", ([{options: addressOptions}, {options: placeOptions}, shipmentVisit]: [{
        options: LovItem[]
      }, { options: LovItem[] }, ShipmentVisit]) => {
        form.getField("shippedToAddress").props.options = observable.shallowArray(addressOptions);
        placeOptions.unshift({value: null, label: '---'});
        form.getField("shippedFromPlace").props.options = observable.shallowArray(placeOptions);
        form.updateFieldsPropValue(dataObject, "shippedToAddress", "shippedFromPlace");
        this.shipmentVisit = shipmentVisit;
      }));
  }

  render() {


    let {dataObject, rootObject, entity, entities, form, formName} = this.props;
    let fields = form.fields;
    let {
      shipmentDate,
      shipmentStatus,
      comment,
      shippedTo,
      shippedToAddress,
      shippedToPlaceDesc,
      registrationNumber,
      shippedFromPlace,
      plannedPaletteCount,
      loadedPaletteCount,
      notLoadedPaletteCount,
      loadingNumber,
      loadingTruckCount,
      unloadingTruckCount,
      shipmentVisit,
      transportationType,
      maxWaitingTime,
      disponentParty,
      pickingList,
      hauler,
      vehicle,
      visitOrder
    } = dataObject.getFormFields(formName);

    const shipmentVisitEntity = mdEntityService.entityMap.get('ShipmentVisit');


    return (

      <form style={{marginTop: 10}}>

        <BlockComp>
          <div className="row">
            <div className="fx col-xs-3">
              <StyledDatePicker {...shipmentDate.props}  />
              <Validate field={shipmentDate} value={shipmentDate.props.value}/>
            </div>
            <div className="col-xs-8 col-xs-offset-1">
              <div style={{color: grey400, marginBottom: 5}}>{shipmentStatus.mdField.formLabelActive}</div>
              <RadioButtonField {...shipmentStatus.props} groupStyle={{display: 'flex'}}
                                optionStyle={{width: 'initial', marginRight: 15}}
                                labelStyle={{whiteSpace: 'nowrap', marginLeft: -10}}
                                iconStyleFn={v => ({fill: SHIPMENTSTATUS_COLORS[v]})}/>
              <Validate field={shipmentStatus} value={shipmentStatus.props.value}/>
            </div>
          </div>
        </BlockComp>


        <div className="row">
          <div className="col-xs-12 col-sm-6">

            <BlockComp className="block-comp-right-border" header={loc.i18n`Customer`} style={{marginBottom: 0}}>
              <div className="row">
                <div className="fx col-xs-12">
                  <StyledSelect  {...shippedTo.props} async={true}
                                 loadOptions={optionsSearch.bind(this, 'Party', {role: [PARTYROLE.CUSTOMER_ROLE]})}
                                 clearable={true}/>
                  <Validate field={shippedTo} value={shippedTo.props.value} onSuccess={this.onShippedToSuccess}/>
                </div>
                <div className="fx col-xs-12">
                  <StyledSelect  {...shippedToAddress.props} clearable={false}/>
                  <Validate field={shippedToAddress} value={shippedToAddress.props.value}
                            onSuccess={this.onShippedToAddressSuccess}/>
                </div>
                <div className="fx col-xs-12">
                  <MdTextField  {...shippedToPlaceDesc.props} />
                </div>
              </div>
              <div className="row">
                <div className="fx col-xs-6">
                  <StyledSelect {...shippedFromPlace.props} clearable={false}/>
                </div>
                <div className="fx col-xs-6">
                  <StyledSelect  {...disponentParty.props} async={true}
                                 loadOptions={optionsSearch.bind(this, 'Party', {
                                   role: [PARTYROLE.CONTACT_ROLE],
                                   disponent: true
                                 })}
                                 clearable={true}/>
                  <Validate field={disponentParty} value={disponentParty.props.value}/>
                </div>
              </div>
              <div className="row">
                <div className="fx col-xs-12">
                  <StyledSelect  {...hauler.props} async={true}
                                 loadOptions={optionsSearch.bind(this, 'Party', {role: [PARTYROLE.HAULER]})}
                                 clearable={true} asterixForAll/>
                  <Validate field={hauler} value={hauler.props.value} onSuccess={this.onHaulerSuccess}/>
                </div>
              </div>
            </BlockComp>

            <BlockComp className="block-comp-right-border" header={loc.i18n`Car`} style={{marginBottom: 0}}>
              <div className="row">
                <div className="fx col-xs-6">
                  <StyledSelect {...vehicle.props} asterixForAll
                                async={true}
                                loadOptions={optionsSearch.bind(this, 'Vehicle', {partyId: dataObject.hauler ? lovValue(dataObject.hauler) : -1})}/>
                  <Validate field={vehicle} value={vehicle.props.value} onSuccess={this.onVehicleSuccess}/>
                </div>
                <div className="fx col-xs-6">
                  <MdTextField {...registrationNumber.props} />
                </div>
              </div>
            </BlockComp>

          </div>


          <div className="col-xs-12 col-sm-6">

            <BlockComp header={loc.i18n`Loading`} style={{marginBottom: 0}}>

              <div className="row">
                <div className="fx col-xs-6">
                  <NumberField {...plannedPaletteCount.props} />
                  <Validate field={plannedPaletteCount} value={plannedPaletteCount.props.value}
                            onSuccess={this.shipmentDetailsFilled}>
                    <NumberFormat precision={4} scale={0}/>
                    <Min min={0}/>
                  </Validate>
                </div>
                <div className="fx col-xs-6">
                  <NumberField {...loadedPaletteCount.props} />
                  <Validate field={loadedPaletteCount} value={loadedPaletteCount.props.value}
                            onSuccess={this.shipmentDetailsFilled}>
                    <NumberFormat precision={4} scale={0}/>
                    <Min min={0}/>
                  </Validate>
                </div>
                <div className="fx col-xs-6">
                  <NumberField {...notLoadedPaletteCount.props} />
                  <Validate field={notLoadedPaletteCount} value={notLoadedPaletteCount.props.value}>
                    <NumberFormat precision={4} scale={0}/>
                    <Min min={0}/>
                  </Validate>
                </div>
                <div className="fx col-xs-6">
                  <MdTextField {...loadingNumber.props} />
                </div>
              </div>

              <div className="row">
                <div className="fx col-xs-6">
                  <NumberField {...loadingTruckCount.props} />
                  <Validate field={loadingTruckCount} value={loadingTruckCount.props.value}>
                    <NumberFormat precision={4} scale={0}/>
                    <Min min={0}/>
                  </Validate>
                </div>
                <div className="fx col-xs-6">
                  <NumberField {...unloadingTruckCount.props} />
                  <Validate field={loadingTruckCount} value={unloadingTruckCount.props.value}>
                    <NumberFormat precision={4} scale={0}/>
                    <Min min={0}/>
                  </Validate>
                </div>
              </div>

              <div className="row">
                <div className="col-xs-6">
                  <MdTextField {...pickingList.props} />
                  <Validate field={pickingList} value={pickingList.props.value}>
                    <HasLength max={12}/>
                    <IsNumber/>
                  </Validate>
                </div>
                <div className="fx col-xs-3">
                  <NumberField {...maxWaitingTime.props} />
                  <Validate field={maxWaitingTime} value={maxWaitingTime.props.value}>
                    <NumberFormat precision={4} scale={0}/>
                    <Min min={0}/>
                  </Validate>
                </div>
                <div className="fx col-xs-3">
                  <NumberField {...visitOrder.props} />
                  <Validate field={visitOrder} value={visitOrder.props.value}>
                    <NumberFormat precision={2} scale={0}/>
                    <Min min={1}/>
                  </Validate>
                </div>
              </div>

              <div className="row">
                <div className="col-xs-3">
                  <div style={{color: grey400, marginBottom: 5}}>{transportationType.mdField.formLabelActive}</div>
                  <RadioButtonField {...transportationType.props} groupStyle={{display: 'flex'}}
                                    optionStyle={{width: 'initial', marginRight: 15}}
                                    labelStyle={{whiteSpace: 'nowrap', marginLeft: -10}}/>
                  <Validate field={transportationType} value={transportationType.props.value}
                            onSuccess={this.onTransportationTypeSuccess}/>
                </div>

                <div className="col-xs-9">
                  <div style={{color: grey400, marginBottom: 5}}>{loc.i18n`Requested loading time`}</div>
                  <ShipmentRequestedTime timeStart={dataObject.requestedLoadingStart}
                                         timeEnd={dataObject.requestedLoadingEnd} changeTimeFn={this.onChangeTime}
                                         dialogTitle={loc.i18n`Requested loading time`}/>
                </div>
              </div>


            </BlockComp>

            <BlockComp style={{marginBottom: 0, paddingBottom: 0}}>
              <div className="row">
                <div className="fx col-xs-12">
                  <StyledSelect  {...shipmentVisit.props} async={true}
                                 loadOptions={optionsSearch.bind(this, 'ShipmentVisit', {unassigned: true})}
                                 clearable={true} asterixForAll/>
                  <Validate field={shipmentVisit} value={shipmentVisit.props.value}
                            onSuccess={this.onShipmentVisitSuccess}/>
                </div>
              </div>
              {(this.shipmentVisit) ? <ShipmentVisitClosedContent dataObject={this.shipmentVisit} entities={entities}
                                                                  entity={shipmentVisitEntity}
                                                                  fields={new Form("ShipmentVisitDriverForm", mdEntityService.getFormDefinition("ShipmentVisitDriverForm")).setupFields(this.shipmentVisit, this.shipmentVisit, shipmentVisitEntity, entities, null)}/> : null}
            </BlockComp>

          </div>

        </div>


        <div className="row">
          <div className="col-xs-12">
            <BlockComp style={{marginBottom: 0, marginTop: 0}}>

              <div className="row">
                <div className="fx col-xs-12">
                  <MdTextField {...comment.props} multiLine={true} rows={3}/>
                </div>
              </div>

            </BlockComp>
          </div>
        </div>


      </form>

    )
  }

  @action onChangeTime = (timeStart, timeEnd) => {
    console.log("onChangeTime: timeStart " + timeStart + ", timeEnd " + timeEnd);
    let {dataObject, rootObject} = this.props;
    dataObject.requestedLoadingStart = timeStart;
    dataObject.requestedLoadingEnd = timeEnd;
    rootObject.$dirty = true;
  }

  @action shipmentDetailsFilled = () => {
    let {dataObject, form} = this.props;
    let result = dataObject.plannedPaletteCount - dataObject.loadedPaletteCount;
    if (!(dataObject.loadedPaletteCount == null)) {
      console.log(dataObject.plannedPaletteCount - dataObject.loadedPaletteCount)

      form.getField("notLoadedPaletteCount").props.value = result;
      dataObject.notLoadedPaletteCount = result;
      form.updateFieldsPropValue(dataObject, "notLoadedPaletteCount");

      if (result < 0) {
        form.getField("notLoadedPaletteCount").props.value = 0;
        dataObject.notLoadedPaletteCount = 0;
        form.updateFieldsPropValue(dataObject, "notLoadedPaletteCount");
      }
    }
  }


  @action onShippedToSuccess = () => {
    let {entities, dataObject, form} = this.props;
    console.log('onShippedToSuccess ', dataObject.shippedTo);

    let partyId = lovValue(dataObject.shippedTo);

    return ((partyId != null) ? Promise.all([optionsSearch('Address', {partyId}),
        shipmentService.computeField("shippedFromPlace", {shippedTo: partyId}),
        shipmentService.computeField("hauler", {partyId})])
      : Promise.all([Promise.resolve({options: []}), Promise.resolve(null), Promise.resolve(null)]))
      .then(action("onShippedToChange-cb1", ([{options: addressOptions}, shippedFromPlaceValue, haulerLov]: [{
        options: LovItem[]
      }, number, LovItem]) => {
        form.getField("shippedToAddress").props.options = observable.shallowArray(addressOptions);
        dataObject.shippedToAddress = (addressOptions.length === 1) ? addressOptions[0] : null;

        let fieldsToUpdate = ["shippedToAddress"];

        if (shippedFromPlaceValue) {
          dataObject.shippedFromPlace = form.getField("shippedFromPlace").props.options.find(lov => lov.value === shippedFromPlaceValue)
          fieldsToUpdate.push("shippedFromPlace");
        }

        if (haulerLov) {
          dataObject.hauler = haulerLov;
          fieldsToUpdate.push("hauler");
        }

        form.updateFieldsPropValue(dataObject, ...fieldsToUpdate);

        if (dataObject.shippedToAddress != null) {
          return this.updateDisponentParty(dataObject, form);
        }
      }));

  };


  @action onShippedToAddressSuccess = () => {
    let {entities, dataObject, form} = this.props;
    console.log('onShippedToAddressSuccess ', dataObject.shippedToAddress);
    return Promise.all([this.computeMaxWaitingTime(dataObject, form),
      this.updateDisponentParty(dataObject, form)]);
  };


  @action onTransportationTypeSuccess = () => {
    let {entities, dataObject, form} = this.props;
    console.log('onTransportationTypeSuccess ', dataObject.transportationType);
    return this.computeMaxWaitingTime(dataObject, form);
  };

  @action onShipmentVisitSuccess = () => {
    let {dataObject, form} = this.props;
    let visitPromise = (dataObject.shipmentVisit) ? shipmentService.readShipmentVisit(lovValue(dataObject.shipmentVisit)) : Promise.resolve(null);
    visitPromise.then((visit) => {
      this.shipmentVisit = visit;
      if (!dataObject.registrationNumber && !!visit) {
        dataObject.registrationNumber = visit.registrationNumber;
        form.updateFieldsPropValue(dataObject, "registrationNumber");
      }
    });
  };


  @action onHaulerSuccess = () => {
    let {dataObject, form} = this.props;
    dataObject.vehicle = undefined;
    form.updateFieldsPropValue(dataObject, "vehicle");
  }

  @action onVehicleSuccess = () => {
    let {dataObject, form} = this.props;
    if (dataObject.vehicle) {
      productService.readVehicle(lovValue(dataObject.vehicle))
        .then(action("onVehicleSuccessA", (vehicle: Vehicle) => {
          dataObject.registrationNumber = vehicle.registrationNumber;
          form.updateFieldsPropValue(dataObject, "registrationNumber");
        }));
    }
  }

  private computeMaxWaitingTime(dataObject, form) {
    return shipmentService.computeField("maxWaitingTime", {
      shippedToAddress: lovValue(dataObject.shippedToAddress),
      transportationType: lovValue(dataObject.transportationType)
    })
      .then(action("computeField-cb", (v: any) => {
        if (v) {
          dataObject.maxWaitingTime = v;
          form.updateFieldsPropValue(dataObject, "maxWaitingTime");
        }
      }));
  }

  private updateDisponentParty(dataObject, form) {
    return shipmentService.computeField("disponentParty", {
      shippedToAddress: lovValue(dataObject.shippedToAddress)
    })
      .then(action("computeDisponent", (v: any) => {
        dataObject.disponentParty = v;
        form.updateFieldsPropValue(dataObject, "disponentParty");
      }));
  }

}






// WEBPACK FOOTER //
// ./src/shipment/component/shipmentOutgoingForm.tsx